import { useDispatch, useSelector } from 'react-redux'

import { DeviceDrawer } from '@/features/device-drawer'
import { GuardTourDrawer } from '@/features/guard-tour-drawer'
import { IncidentDrawer } from '@/features/incident-drawer'
import { SOPModal } from '@/features/sop-drawer'
import {
  closeDeviceDrawer,
  closeGuardTourDrawer,
  closeIncidentDrawer,
  closeIncidentMapPanelDrawer,
  closeSOPIncidentDrawer,
  closeSOPModal,
  closeTraceLogDrawer,
  closeWorkflowDrawer,
  selectGuardTourOpen,
  selectIsDeviceDrawerOpen,
  selectIsIncidentDrawerOpen,
  selectIsSOPModalOpen,
  setDevice,
  setGuardTourId,
  setIncident,
  setSOP,
} from '@/redux/ui/uiSlice'

export const Drawers = () => {
  const dispatch = useDispatch()

  const handleCloseDeviceDrawer = () => {
    dispatch(setDevice({ id: null, type: null }))
    dispatch(closeDeviceDrawer())
  }

  const handleCloseIncidentDrawer = () => {
    dispatch(setIncident({ id: null }))
    dispatch(closeIncidentDrawer())
    dispatch(closeTraceLogDrawer())
    dispatch(closeSOPIncidentDrawer())
    dispatch(closeWorkflowDrawer())
    dispatch(closeIncidentMapPanelDrawer())
  }

  const handleCloseSOPModal = () => {
    dispatch(setSOP({ id: null }))
    dispatch(closeSOPModal())
  }

  const handleCloseGuardTourDrawer = () => {
    dispatch(setGuardTourId({ id: null }))
    dispatch(closeGuardTourDrawer())
  }

  const isIncidentDrawerOpen = useSelector(selectIsIncidentDrawerOpen)
  const isDeviceDrawerOpen = useSelector(selectIsDeviceDrawerOpen)
  const isSOPModalOpen = useSelector(selectIsSOPModalOpen)
  const isGuardTourOpen = useSelector(selectGuardTourOpen)

  return (
    <>
      {isIncidentDrawerOpen && (
        <IncidentDrawer
          isOpen={isIncidentDrawerOpen}
          onClose={handleCloseIncidentDrawer}
        />
      )}
      {/* Not gated on `isDeviceDrawerOpen` like its siblings: DeviceDrawer owns
          the edit-device modal, which must outlive the drawer (ENG-33365). It
          renders nothing itself while the drawer is closed. */}
      <DeviceDrawer
        isOpen={isDeviceDrawerOpen}
        onClose={handleCloseDeviceDrawer}
      />
      {isSOPModalOpen && (
        <SOPModal isOpen={isSOPModalOpen} onClose={handleCloseSOPModal} />
      )}
      {isGuardTourOpen && (
        <GuardTourDrawer
          isOpen={isGuardTourOpen}
          onClose={handleCloseGuardTourDrawer}
        />
      )}
    </>
  )
}
